import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import branchesUK from "@/.sourceflow/branches_uk.json";
import branchesUS from "@/.sourceflow/branches_us.json";

export const useBranches = ({ locale, limit } = {}) => {
  const collection = useSourceFlowCollection(locale == "/us/" ? branchesUS : branchesUK);

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useBranches;
